









































































































































































































































































































































































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
  BFormDatepicker,
  BFormFile,
  VBTooltip,
  BFormTextarea,
  BAlert
} from "bootstrap-vue";
import { Component, Prop, Vue, Watch, PropSync } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { ContratCreateModel } from "@/api/models/contrats/contrat";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { DetailsUtilisateur, ShortUtilisateur } from "@/api/models/utilisateurs/utilisateur";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { Opportunite, ShortOpportunite } from "@/api/models/opportunites/opportunite";
import { Contact } from "@/api/models/contacts/contact";
import { AdvancedContratCreateModel } from "@/api/models/contrats/advancedContrat";
import { refineProps } from "@fullcalendar/common";
import { Partenaire } from "@/api/models/partenaires/partenaire";
import { Fournisseur } from "@/api/models/fournisseurs/fournisseur";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
    BFormDatepicker,
    BFormFile,
    BFormTextarea,
    BAlert
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  name: "create-contrat",
})
export default class CreateAdvancedContrat extends Vue {
  @Prop({ required: true, type: Boolean }) isAddNewContratSidebarActive!: boolean;
  
  @PropSync('transformToContractOpportuniteId', { type: String, default: null })
  opportuniteIdFromTransform!: string | null;

  isAddingFromOpportunite = false;
  loadingOpportunite = false;

  loading = false
  required = required;

  listTypeContrat = [];
  totalCountTypeContrat = 0;

  newContrat: AdvancedContratCreateModel = {};
  opportunite: Opportunite | null = null;

  paginatedListUsers: PaginatedList<ShortUtilisateur> = new PaginatedList<ShortUtilisateur>();
  paginatedListOpportunites: PaginatedList<ShortOpportunite> = new PaginatedList<ShortOpportunite>();
  paginatedListContactsComptabilite: PaginatedList<Contact> = new PaginatedList<Contact>();
  paginatedListPartenaires: PaginatedList<Partenaire> = new PaginatedList<Partenaire>();
  paginatedListFournisseurs: PaginatedList<Fournisseur> = new PaginatedList<Fournisseur>();

  listEcheancierFacturation: { code: string; libelle: string; }[] = [];
  listConditionPaiement: { code: string; libelle: string; }[] = [];
  listEntiteFacturation: { code: string; libelle: string; }[] = [];
  listTypePrestation: { code: string; libelle: string; }[] = [];

  mappingsNatureOffreTypeContrat: { source: string; destination: string, canQualiopi?: boolean }[] = [];

  refreshIndex = 0

  canQualiopi = false

  get isAdminContrat() {
    return !(this.isAddingFromOpportunite && !this.$can('ENTREPRISES_CONTRATSV2:admin'));
  }

  async created() {
    const opportuniteIdToLoad = this.opportuniteIdFromTransform;
    this.isAddingFromOpportunite = this.opportuniteIdFromTransform !== null;

    if (opportuniteIdToLoad) this.loadingOpportunite = true;
    
    await Promise.all([
      this.getTypeContrat(),
      this.loadEcheancierFacturation(),
      this.loadConditionPaiement(),
      this.loadEntiteFacturation(),
      this.loadTypePrestation(),
      this.loadOpportunites(null),
      this.loadMapping()
    ]);
    
    if (opportuniteIdToLoad) {
      await this.loadOpportuniteDetails(opportuniteIdToLoad);
      this.newContrat.opportuniteId = opportuniteIdToLoad;
      this.loadingOpportunite = false;
      this.refreshIndex++;
    }

    this.loadUsers(null);
    this.loadListContactComptabilite(null);
  }

  async loadMapping() {
    const param = await this.$http.myressif.parametres.getByNom("mapping_natureOffre_typeContrat");
    this.mappingsNatureOffreTypeContrat = JSON.parse(param.valeur);
  }

  @Watch('newContrat.opportuniteId')
  async onOpportuniteIdChange(newVal: string | null, oldVal: string | null) {
    if (!newVal || newVal === oldVal) {
      return;
    }
    
    if (newVal === this.opportunite?.id) {
      return;
    }
    
    await this.loadOpportuniteDetails(newVal);
  }

  typeContratChanged(value: string) {
    this.canQualiopi = this.mappingsNatureOffreTypeContrat.find(m => m.destination === value)?.canQualiopi ?? false;
    this.refreshIndex++;
  }

  resetForm() {
    this.newContrat = {};
    this.opportunite = null;
    this.paginatedListUsers = new PaginatedList<ShortUtilisateur>();
    this.paginatedListOpportunites = new PaginatedList<ShortOpportunite>();
    this.paginatedListContactsComptabilite = new PaginatedList<Contact>();
  }

  async loadOpportuniteDetails(opportuniteId: string) {
    try {
      const response = await this.$http.myressif.entreprises
        .getOpportuniteById(this.$route.params.id, opportuniteId);
      
      this.opportunite = response;
      
      this.newContrat.nom = response.libelle;
      this.newContrat.montant = response.montant;
      this.newContrat.dateDemarrage = response.dateDebutSouhaitee;
      this.newContrat.entiteFacturation = response.entiteFacturation;
      this.newContrat.nombreAdvancedContrats = response.nombreAdvancedContrats;
      this.newContrat.typePrestation = response.typePrestation;
      this.newContrat.partenaireId = response.partenaireId;
      this.newContrat.fournisseurId = response.fournisseurId;
      
        if (response.partenaireId && response.partenaireNom) {
          const partenaireExists = this.paginatedListPartenaires.items.some(c => c.id === response.partenaireId)
          if (!partenaireExists) {
            this.paginatedListPartenaires.items.unshift({
              id: response.partenaireId,
              nom: response.partenaireNom
            } as Partenaire)
            this.paginatedListPartenaires.totalCount++
          }
        }

        if (response.fournisseurId && response.fournisseurNom) {
          const fournisseurExists = this.paginatedListFournisseurs.items.some(c => c.id === response.fournisseurId)
          if (!fournisseurExists) {
            this.paginatedListFournisseurs.items.unshift({
              id: response.fournisseurId,
              nom: response.fournisseurNom
            } as Fournisseur)
            this.paginatedListFournisseurs.totalCount++
          }
        }

      if (response.naturesOffre.length == 1) {
        
        this.newContrat.typeContrat = this.mappingsNatureOffreTypeContrat.find(m => m.source === response.naturesOffre[0])?.destination;
        this.typeContratChanged(this.newContrat.typeContrat!);
      }
      
      if (!this.paginatedListOpportunites.items.some(o => o.id === response.id)) {
        this.paginatedListOpportunites.items.unshift({
          id: response.id,
          libelle: response.libelle
        } as ShortOpportunite);
        this.paginatedListOpportunites.totalCount++;
      }
      
      this.refreshIndex++;
    } catch (error: any) {
      errorAlert.fire({
        text: error?.response?.data?.detail ?? error.message,
      });
    }
  }

  async getTypeContrat() {
    try {
      const res: any = await this.$http.myressif.parametres.getByNom("type_advanced_contrat_adherent");
      this.listTypeContrat = res ? JSON.parse(res.valeur) : [];
    } catch (error: any) {
      errorAlert.fire({
        text: error?.response?.data?.detail ?? error.message,
      });
    }
  }

  async submit() {
    if (!this.isAdminContrat) {
      this.newContrat.opportuniteId = this.opportunite?.id;
      this.newContrat.entiteFacturation = this.opportunite?.entiteFacturation;
      this.newContrat.typePrestation = this.opportunite?.typePrestation;
    }
    this.loading = true;
    try {
      await this.$http.myressif.entreprises
        .createAdvancedContratOnEntreprise(this.$route.params.id, this.newContrat);
      
      successAlert.fire({
        timer: 3500,
        title: "Création d'un contrat",
        text: "Contrat créé avec succès",
      });
      
      this.$emit("refresh-contrat");
      this.$emit("update:is-add-new-contrat-sidebar-active", false);
    } catch (error: any) {
      if (error?.response?.data?.errors && Object.keys(error.response.data.errors).length) {
        errorAlert.fire({
          text: error.response.data.errors[Object.keys(error.response.data.errors)[0]],
        });
      } else {
        errorAlert.fire({
          text: error?.response?.data?.detail ?? error.message,
        });
      }
    } finally {
      this.loading = false;
    }
  }

  async loadUsers(params: any) {
    if (!params || params?.reset) {
      this.paginatedListUsers.items = this.paginatedListUsers.items.filter(
        u => u.id === this.newContrat.responsableId
      );
      this.paginatedListUsers.totalCount = this.paginatedListUsers.items.length;
    }

    const response = await this.$http.myressif.utilisateurs.paginatedList(
      params?.search ? 1 : params?.pageNumber ?? 1,
      params?.pageSize ?? 10,
      params?.search ?? "",
      params?.hiddenUser ?? false,
      params?.orderBy ?? 'nom',
      params?.orderByDescending ?? false,
      null,
      null,
      true
    );
    
    this.paginatedListUsers.items = this.paginatedListUsers.items.concat(
      response.items.filter((ri: ShortUtilisateur) => !this.paginatedListUsers.items.some(lsi => lsi.id == ri.id))
    ).map((x: ShortUtilisateur) => ({
      ...x,
      completeLabel: `${x.nom} ${x.prenom}`
    }));
    
    this.paginatedListUsers.hasNextPage = response.hasNextPage;
    this.paginatedListUsers.hasPreviousPage = response.hasPreviousPage;
    this.paginatedListUsers.pageIndex = response.pageIndex;
    this.paginatedListUsers.totalCount = response.totalCount;
    this.paginatedListUsers.totalPages = response.totalPages;
  }

  async loadListPartenaires(params: any) {
    if (!params || params?.reset) {
      this.paginatedListPartenaires.items = this.paginatedListPartenaires?.items.filter(u => this.newContrat.partenaireId === u.id);
      this.paginatedListPartenaires.totalCount = this.paginatedListPartenaires.items.length;
    }

    await this.$http.myressif.partenaires
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
        params?.search ?? "",
        params?.hiddenUser ?? false,
      )
      .then((response: PaginatedList<Partenaire>) => {
        this.paginatedListPartenaires.items = this.paginatedListPartenaires!.items.concat(
            response.items.filter(
              (ri) => !this.paginatedListPartenaires!.items.some((lsi) => lsi.id == ri.id)
            )
          );
        this.paginatedListPartenaires.hasNextPage = response.hasNextPage
        this.paginatedListPartenaires.hasPreviousPage = response.hasPreviousPage
        this.paginatedListPartenaires.pageIndex = response.pageIndex
        this.paginatedListPartenaires.totalCount = response.totalCount
        this.paginatedListPartenaires.totalPages = response.totalPages
      });
  }

  async loadListFournisseurs(params: any) {
    if (!params || params?.reset) {
      this.paginatedListFournisseurs.items = this.paginatedListFournisseurs?.items.filter(u => this.newContrat.fournisseurId === u.id);
      this.paginatedListFournisseurs.totalCount = this.paginatedListFournisseurs.items.length;
    }

    await this.$http.myressif.fournisseurs
      .paginatedList(
        params?.search ? 1 : params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy ?? 'nom',
        params?.orderByDescending ?? false,
        params?.search ?? "",
        params?.hiddenUser ?? false,
      )
      .then((response: PaginatedList<Fournisseur>) => {
        this.paginatedListFournisseurs.items = this.paginatedListFournisseurs!.items.concat(
            response.items.filter(
              (ri) => !this.paginatedListFournisseurs!.items.some((lsi) => lsi.id == ri.id)
            )
          );
        this.paginatedListFournisseurs.hasNextPage = response.hasNextPage
        this.paginatedListFournisseurs.hasPreviousPage = response.hasPreviousPage
        this.paginatedListFournisseurs.pageIndex = response.pageIndex
        this.paginatedListFournisseurs.totalCount = response.totalCount
        this.paginatedListFournisseurs.totalPages = response.totalPages
      });
  }

  async loadOpportunites(params: any) {
    if (!params || params?.reset) {
      this.paginatedListOpportunites.items = this.paginatedListOpportunites.items.filter(
        o => o.id === this.newContrat.opportuniteId
      );
      this.paginatedListOpportunites.totalCount = this.paginatedListOpportunites.items.length;
    }

    const response = await this.$http.myressif.entreprises.getListOpportunitesByEntrepriseId(
      this.$route.params.id,
      params?.search ? 1 : params?.pageNumber ?? 1,
      params?.pageSize ?? 10,
      params?.orderBy ?? 'libelle',
      params?.orderByDescending ?? false
    );
    
    this.paginatedListOpportunites.items = this.paginatedListOpportunites.items.concat(
      response.items.filter((ri: ShortOpportunite) => !this.paginatedListOpportunites.items.some(lsi => lsi.id == ri.id))
    );
    
    this.paginatedListOpportunites.hasNextPage = response.hasNextPage;
    this.paginatedListOpportunites.hasPreviousPage = response.hasPreviousPage;
    this.paginatedListOpportunites.pageIndex = response.pageIndex;
    this.paginatedListOpportunites.totalCount = response.totalCount;
    this.paginatedListOpportunites.totalPages = response.totalPages;
  }

  async loadListContactComptabilite(params: any) {
    if (!params || params?.reset) {
      this.paginatedListContactsComptabilite.items = this.paginatedListContactsComptabilite.items.filter(
        c => c.id === this.newContrat.contactComptabiliteId
      );
      this.paginatedListContactsComptabilite.totalCount = this.paginatedListContactsComptabilite.items.length;
    }

    const response = await this.$http.myressif.entreprises.getListContactsByEntrepriseId(
      this.$route.params.id,
      params?.pageNumber ?? 1,
      params?.pageSize ?? 10,
      params?.orderBy,
      params?.orderByDescending,
      params?.search ?? ""
    );
    
    this.paginatedListContactsComptabilite.items = this.paginatedListContactsComptabilite.items.concat(
      response.items.filter((ri: any) => !this.paginatedListContactsComptabilite.items.some(lsi => lsi.id == ri.id))
    );
    
    this.paginatedListContactsComptabilite.hasNextPage = response.hasNextPage;
    this.paginatedListContactsComptabilite.hasPreviousPage = response.hasPreviousPage;
    this.paginatedListContactsComptabilite.pageIndex = response.pageIndex;
    this.paginatedListContactsComptabilite.totalCount = response.totalCount;
    this.paginatedListContactsComptabilite.totalPages = response.totalPages;
  }

  async loadParametre(parametre: string): Promise<{code: string, libelle: string}[]> {
    try {
      const res: {valeur: string} = await this.$http.myressif.parametres.getByNom(parametre);
      return res ? JSON.parse(res.valeur) : [];
    } catch (error: any) {
      errorAlert.fire({
        text: error?.response?.data?.detail ?? error.message,
      });
      return [];
    }
  }
  
  async loadEcheancierFacturation() {
    this.listEcheancierFacturation = await this.loadParametre('opportunites_echeancier_facturation');
  }

  async loadConditionPaiement() {
    this.listConditionPaiement = await this.loadParametre('opportunites_condition_paiement');
  }

  async loadEntiteFacturation() {
    this.listEntiteFacturation = await this.loadParametre('opportunites_entite_facturation');
  }

  async loadTypePrestation() {
    this.listTypePrestation = await this.loadParametre('opportunites_type_prestation');
  }
}
